import { FormProvider } from 'react-hook-form';
import { useEditClientAdminUserForm } from './hooks';
import { convertToPresentationProps } from './logics/convertToPresentationProps';
import { EditClientAdminUserFormPresentation } from './presentations';

type Props = {
  clientAdminUserId: number;
};

export const EditClientAdminUserForm: React.FC<Props> = ({ clientAdminUserId }) => {
  const {
    state: { data, methods, isSubmitDisabled },
    actions: { handleSubmit },
  } = useEditClientAdminUserForm({ clientAdminUserId });

  const { title } = convertToPresentationProps({ data });

  return (
    <FormProvider {...methods}>
      <EditClientAdminUserFormPresentation
        isSubmitDisabled={isSubmitDisabled}
        onSubmit={handleSubmit}
        title={title}
      />
    </FormProvider>
  );
};
